import React from 'react'
import { Button } from '@mui/material'
import { GetApp } from '@mui/icons-material'
import { downloadInstaller, downloadTdmSoftware } from '../../functions/downloadSoftware'
import DialogForMac from './DialogForMac'

const csId = 'BE39B0AE-3649-4899-807E-51C73F70FEE7'

const ButtonDownloadSoftware = ({ version, text }: { version: string; text: string }) => {
  const [open, setOpen] = React.useState(false)

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = (userAccept: boolean) => {
    if (userAccept) {
      downloadInstaller(csId)
    }
    setOpen(false)
  }

  const handleDownloadSoftware = () => {
    switch (version.toLowerCase()) {
      case 'launcher':
        // downloadInstaller('launcher')
        // Next line is just temporary until we have the installer for the launcher
        downloadFromS3(
          'https://gemvision.s3.us-east-1.amazonaws.com/software/launcher/beta/Gemvision Launcher Setup 7.0.0.exe',
          text
        )
        break
      case 'launcher-cs-rhino8':
        downloadFromS3(
          'https://gemvision.s3.us-east-1.amazonaws.com/software/launcher/beta/Gemvision Launcher Setup 7.0.0.exe',
          text
        )
        break
      case 'matrixgold':
        downloadInstaller('be1f6ce0-a17b-11e8-98b7-310b8b71d1dd')
        break
      case 'countersketch':
        if (navigator.platform.includes('Mac')) {
          return handleClickOpen()
        }
        downloadInstaller(csId)
        break
      case 'matrix9':
        downloadFromS3('https://gemvision.com/files/Matrix9.0.exe', text)
        break
      case 'matrix8':
        downloadFromS3('https://gemvision.com/files/Matrix8.0.exe', text)
        break
      case 'clayoo':
        downloadTdmSoftware(
          JSON.stringify({
            data: { product: { name: 'Clayoo', version: '2.6.0.0' }, stage: 'STABLE', rhino: '6' },
            version: '4'
          })
        )
        break
      case 'rhinogold':
        downloadTdmSoftware(
          JSON.stringify({
            data: { product: { name: 'RhinoGold', version: '6.6.0.0' }, stage: 'STABLE', rhino: '6' },
            version: '4'
          })
        )
        break
      default:
        console.log(`Version "${version}" is not configured`)
        return
    }
  }

  const downloadFromS3 = (uri: string, name: string) => {
    const link = document.createElement('a')
    link.download = name
    link.href = uri
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  return (
    <React.Fragment>
      <Button variant='contained' color='secondary' startIcon={<GetApp />} onClick={() => handleDownloadSoftware()}>
        {text}
      </Button>
      <DialogForMac open={open} handleClose={handleClose} />
    </React.Fragment>
  )
}

export default ButtonDownloadSoftware
